import * as React from "react";
import {
  Stack,
  DefaultButton,
  Fabric,
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  IColumn,
  TooltipHost,
  IStackTokens,
  SearchBox,
  Text,
  IDetailsListProps,
  IDetailsRowStyles,
  DetailsRow,
  Callout,
  DirectionalHint,
  FocusTrapZone,
  Calendar,
  DayOfWeek,
  Dropdown,
  IDropdownOption,
  TagPicker,
  ITag,
  IBasePickerSuggestionsProps,
  PrimaryButton,
} from "office-ui-fabric-react";
import { IConfirmDialog, ICustomerVM } from "../../vm";
import { getAllCustomers } from "../../services/customers/CustomerService";
import { withToastContext } from "../common/ToastProvider";
// import AddCustomerDialog from './AddCustomerDialog';
import { withConfirmDialogContext } from "../common/ConfirmDialogProvider";
import { Loading } from "../../services/Loading";
// import AddCustomerRacksDialog from "../customer-racks/AddCustomerRacksDialog";
import PageTitle from "../common/PageTitle";
import NoDataTile from "../common/NoDataTile";
import { mdiChevronLeft, mdiChevronRight, mdiFilterOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { THEME } from "../../utils/Styles";
import { isAdmin } from "../../services/UtilService";
import { RouteComponentProps, withRouter } from "react-router";
import {
  childrenGap,
  DayPickerStrings,
  DC_STATUS_DROPDOWN,
  DC_STATUS_DICT,
  childrenGap8,
} from "../common/Constants";
import { ReactComponent as CustomerIcon } from "../../images/customer.svg";
import moment from "moment";
import { getAllDataCenters } from "../../services/datacenter/DatacenterService";
import CustomPagination from "../common/CustomPagination";

let calendarButtonElement: HTMLElement;
export interface CustomerMainProps
  extends IConfirmDialog,
    RouteComponentProps {}

export interface CustomerMainState {
  //   addCustomerDialog: {
  //     isOpen: boolean;
  //     index: number | undefined;
  //     data: ICustomers | undefined;
  //   };
  customer?: string;
  customers: {
    data: ICustomerVM[];
    totalCount: number;
    search: {
      offset: number;
      limit: number;
      search: string;
      showCircuitIdAndDc: boolean;
      showReportStatus: boolean;
      customerReportStatus?: number;
      date: Date;
      datacenterIds: string;
      showPagination: boolean;
      showCEMName: boolean;
    };
    hasMoreCustomers: boolean;
  };
  isLoading: boolean;
  iscustomersLoaded: boolean;
  showCallender: boolean;
  showStatusFilter: boolean;
  datacenterOptions: ITag[];
  selectedDatacenters: ITag[];
}

class CustomerMain extends React.Component<
  CustomerMainProps,
  CustomerMainState
> {
  queryParams = new URLSearchParams(this.props.location.search);
  constructor(props: CustomerMainProps) {
    super(props);
    this.state = {
      //   addCustomerDialog: {
      //     isOpen: false,
      //     index: undefined,
      //     data: undefined,
      //   },
      customer: undefined,
      customers: {
        data: [],
        totalCount: 0,
        search: {
          offset: this.queryParams.get("from")
            ? Number(this.queryParams.get("from"))
            : 0,
          // offset: 0,
          limit: 12,
          search: this.queryParams.get("search")
            ? (this.queryParams.get("search") as string)
            : "",
          // search: "",
          showCircuitIdAndDc: true,
          showReportStatus: true,
          customerReportStatus: this.queryParams.get("customerReportStatus")
            ? Number(this.queryParams.get("customerReportStatus"))
            : 10,
          // customerReportStatus: 10,
          date: this.queryParams.get("date")
            ? new Date(this.queryParams.get("date") as string)
            : new Date(),
          // date: new Date(),
          datacenterIds: this.queryParams.get("datacenterIds")
            ? (this.queryParams.get("datacenterIds") as string)
            : "",
          showPagination: true,
          showCEMName: true,
        },
        hasMoreCustomers: true,
      },
      isLoading: false,
      iscustomersLoaded: false,
      showCallender: false,
      showStatusFilter: this.queryParams.get("fromDashboard")
        ? true
        : false ||
          this.queryParams.get("customerReportStatus") != "10" ||
          this.queryParams.get("datacenterIds") != "",
      datacenterOptions: [],
      selectedDatacenters: [],
    };
  }

  componentDidUpdate = async (
    prevProps: CustomerMainProps,
    prevState: CustomerMainState
  ) => {
    if (prevState.customers.search !== this.state.customers.search) {
      let searchObj = { ...this.state.customers.search };
      if (searchObj.customerReportStatus === 10) {
        delete searchObj.customerReportStatus;
      }

      let customers: any = await getAllCustomers(searchObj);

      if (customers?.success) {
        this.setState({
          customers: {
            ...this.state.customers,
            data: this.getDetailListData(customers.data.customers),
            totalCount: customers.data.count,
            hasMoreCustomers:
              customers.data.length === this.state.customers.search.limit,
          },
        });
      }
    }
    window.history.replaceState(
      null,
      "",
      `/customers?from=${this.state.customers.search.offset}&to=${
        this.state.customers.search.offset + this.state.customers.search.limit
      }&search=${this.state.customers.search.search}&date=${moment(
        this.state.customers.search.date
      ).format("MM/DD/YYYY")}&customerReportStatus=${
        this.state.customers.search.customerReportStatus
      }&datacenterIds=${this.state.customers.search.datacenterIds}`
    );
    // console.log("componentDidUpdate called");
  };

  componentDidMount = async () => {
    let verifyAdmin = isAdmin();
    if (verifyAdmin) {
      await this.getAllCustomers();
      await this.getAllDatacenters();
    } else {
      this.props.history.push("/not-authorized");
    }
    // console.log("location", this.props.location.search);
  };

  getAllCustomers = async () => {
    this.setState({ isLoading: true });
    let searchObj = { ...this.state.customers.search };
    if (searchObj.customerReportStatus === 10) {
      delete searchObj.customerReportStatus;
    }
    let result: any = await getAllCustomers({
      ...searchObj,
      customerId: this.state.customer,
    });

    if (result && result.success) {
      this.setState((prevState) => ({
        customers: {
          ...prevState.customers,
          data: this.getDetailListData(result.data?.customers || []),
          totalCount: result.data?.count || 0,
          hasMoreCustomers:
            result.data.length === prevState.customers.search.limit,
        },
      }));
    } else {
      //   this.props.toast.show('Error while getting customers', 'error');
    }
    this.setState({ isLoading: false });
  };

  getAllDatacenters = async () => {
    this.setState({ isLoading: true });

    let result = await getAllDataCenters();

    if (result && result.success) {
      const options: ITag[] = [];
      result.data.forEach((d) => {
        options.push({ key: d._id as string, name: d.name });
      });
      const selectedItem = options.filter((d) =>
        this.state.customers.search.datacenterIds
          .split(",")
          .includes(d.key as string)
      );
      this.setState({
        datacenterOptions: options,
        selectedDatacenters: selectedItem,
      });
    } else {
      //   this.props.toast.show('Error while getting datacenters', 'error');
    }
    this.setState({ isLoading: false });
  };

  //   handleAddDialogOpen = (isOpen: boolean, index?: number) => {
  //     let customer = undefined;
  //     if (index !== undefined) {
  //       customer = { ...this.state.customers.data[index] };
  //     }
  //     this.setState({
  //       addCustomerDialog: {
  //         isOpen: isOpen,
  //         index: index,
  //         data: customer,
  //       },
  //     });
  //   };

  handleAddDialogCustomerRackOpen = (isOpen: boolean) => {
    this.setState({
      iscustomersLoaded: isOpen,
    });
  };

  handleLoading = () => {
    this.setState((prevState) => ({
      isLoading: !prevState.isLoading,
    }));
  };

  //   handleCloseCustomerDialog = (data: ICustomers) => {
  //     let customers = [...this.state.customers.data];
  //     if (data) {
  //       if (this.state.addCustomerDialog.index !== undefined) {
  //         customers[this.state.addCustomerDialog.index] = data;
  //       } else {
  //         customers.unshift(data);
  //       }
  //     }
  //     this.setState((prevState) => ({
  //       addCustomerDialog: {
  //         isOpen: false,
  //         index: undefined,
  //         data: undefined,
  //       },
  //       customers: {
  //         ...prevState.customers,
  //         data: customers,
  //       },
  //     }));
  //   };

  handleCloseCustomerRackDialog = () => {
    this.setState({
      iscustomersLoaded: false,
    });
  };
  //   deleteCustomer = (customer: ICustomers, customerIndex: number) => {
  //     this.props.confirmDialog.show(
  //       'Are You Sure',
  //       'Do you want to delete customer',
  //       async () => {
  //         this.setState({
  //           isLoading: true,
  //         });
  //         let result = await deleteCustomer(customer._id);
  //         if (result.success) {
  //           this.props.toast.show('Customer deleted successfully', 'success');
  //           let customers = [...this.state.customers.data];
  //           customers.splice(customerIndex, 1);
  //           this.setState((prevState) => ({
  //             customers: {
  //               ...prevState.customers,
  //               data: customers,
  //             },
  //             isLoading: false,
  //           }));
  //         } else {
  //           this.setState({
  //             isLoading: false,
  //           });
  //           this.props.toast.show(
  //             result.message.includes('unlink')
  //               ? result.message
  //               : 'Error while deleting Customer',
  //             'error'
  //           );
  //         }
  //       }
  //     );
  //   };
  getCustomersFrom = (from: number) => {
    this.setState(
      (prevState) => ({
        customers: {
          ...prevState.customers,
          search: {
            ...prevState.customers.search,
            offset: from,
          },
        },
      })
      // () => this.getAllCustomers()
    );

    // getUsersFrom = (from: number) => {
    //   this.setState(
    //     (prevState) => ({
    //       searchObj: {
    //         ...prevState.searchObj,
    //         from: from,
    //       },
    //     }),
    //     this.getUsersList
    //   );
    // };

    // this.queryParams.set("from", String(from));
    // this.queryParams.set(
    //   "to",
    //   String(from + this.state.customers.search.limit)
    // );
    // this.props.history.push(
    //   this.props.location.pathname + "?" + this.queryParams.toString()
    // );
  };

  // downloadAccessReportPdf = async () => {
  //   let result = await fetch(`${API_URL}access-reports`, {
  //     method: "GET",
  //     headers: {
  //       at: getToken(),
  //     },
  //   });
  //   let pdf = await result.blob();
  //   const pdfFile = await new Blob([pdf], { type: "application/pdf" });
  //   const pdfFileURL = await URL.createObjectURL(pdfFile);
  //   var a: any = document.createElement("a");
  //   document.body.appendChild(a);
  //   a.style = "display:none";
  //   a.href = pdfFileURL;
  //   a.download = `ABG Monthly Access Report.pdf`;
  //   a.click();
  // };

  // downloadCardHolderReportPdf = async () => {
  //   let result = await fetch(`${API_URL}card-holder-reports`, {
  //     method: "GET",
  //     headers: {
  //       at: getToken(),
  //     },
  //   });
  //   let pdf = await result.blob();
  //   const pdfFile = await new Blob([pdf], { type: "application/pdf" });
  //   const pdfFileURL = await URL.createObjectURL(pdfFile);
  //   var a: any = document.createElement("a");
  //   document.body.appendChild(a);
  //   a.style = "display:none";
  //   a.href = pdfFileURL;
  //   a.download = `ABG ACTIVE CARD Holder.pdf`;
  //   a.click();
  // };

  _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column?.key) {
      case "actions":
        return (
          // <Stack horizontal>
          //   <DefaultButton
          //     text='Cardholder Report'
          //     onClick={() => {
          //       this.downloadCardHolderReportPdf();
          //     }}
          //   />
          //   &nbsp;&nbsp;
          //   <DefaultButton
          //     text='Access Report'
          //     onClick={() => {
          //       this.downloadAccessReportPdf();
          //     }}
          //   />
          // </Stack>
          // <Stack>
          <DefaultButton
            // width={30}
            // styles={{}}
            text="View"
            onClick={() => {
              this.props.history.push(`/customers/${item._id}`);
            }}
          />
          // </Stack>
          // <Stack horizontal>
          //   <TooltipHost
          //     content="View"
          //     id={`view`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span
          //       onClick={() => {
          //         this.props.history.push(`/customers/${item._id}`);
          //       }}
          //     >
          //       <Icon
          //         path={mdiEyeOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "customerLocation":
        return (
          <Stack horizontal wrap tokens={childrenGap8}>
            {item.customerLocation && item.customerLocation.length > 0
              ? item.customerLocation.map((i: any, index: number) => (
                  <Stack.Item className="ms-DetailsRow-cell">
                    {i +
                      (item.customerLocation.length - 1 !== index ? ", " : "")}
                  </Stack.Item>
                ))
              : "NA"}
          </Stack>
        );
      case "dcStatus":
        return (
          <Stack horizontal wrap tokens={childrenGap8}>
            {item.dcStatus && item.dcStatus
              ? item.dcStatus.map((i: any, index: number) => (
                  <Stack.Item className="ms-DetailsRow-cell">
                    {i + (item.dcStatus.length - 1 !== index ? ", " : "")}
                  </Stack.Item>
                ))
              : "NA"}
          </Stack>
        );
      // case "dcStatus":
      //   return <span>{item.dcStatus ? item.dcStatus : "NA"}</span>;
      case "name":
        return (
          <Text styles={{ root: { fontWeight: 600 } }}>
            {item[column.fieldName as any]}
          </Text>
        );
      case "number":
        return (
          <Text styles={{ root: { fontWeight: 600 } }}>
            {this.state.customers.search.offset + index + 1 + "."}
          </Text>
        );
      default:
        return <span>{item[column?.fieldName as any] || "NA"}</span>;
    }
  };

  _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  private _searchCustomers = async (value: any, type: string) => {
    // let searchObj = {
    //   offset: 0,
    //   limit: 12,
    //   showCircuitIdAndDc: true,
    //   showReportStatus: true
    // };
    let searchObj = { ...this.state.customers.search };

    searchObj.offset = 0;
    searchObj.limit = 12;
    // this.queryParams.set("from", String(0));
    // this.queryParams.set("to", String(12));
    if (type != "datacenter") {
      if (typeof value === "string") {
        searchObj.search = value;
        // this.queryParams.set("search", value);
      } else if (typeof value === "number") {
        searchObj.customerReportStatus = value;
        // this.queryParams.set("customerReportStatus", String(value));
      } else {
        searchObj.date = value;
        // this.queryParams.set("date", String(moment(value).format("MM/DD/YYYY")));
      }
    }

    if (searchObj.customerReportStatus === 10) {
      delete searchObj.customerReportStatus;
    }

    // this.props.history.push(
    //   this.props.location.pathname + "?" + this.queryParams.toString()
    // );

    // let customers: any = await getAllCustomers(searchObj);

    if (
      !searchObj.customerReportStatus &&
      searchObj.customerReportStatus !== 0
    ) {
      searchObj.customerReportStatus = 10;
    }
    // let customers = await getAllcustomers({ search: search, roleId: this.state.role });
    // if (customers?.success) {
    this.setState({
      customers: {
        ...this.state.customers,
        // data: this.getDetailListData(customers.data),
        search: searchObj as any,
        // hasMoreCustomers:
        //   customers.data.length === this.state.customers.search.limit,
      },
      showCallender: false,
    });
    // }
  };

  getDetailListData = (data: ICustomerVM[]) => {
    const dataArr = data.map((d) => {
      // d.name = d.name + ' (' + d.regSapNo + ')';
      if (d.location)
        d["customerLocation"] = d.location.map(
          (l) =>
            l?.datacenter?.name + (l?.circuitId ? " (" + l.circuitId + ")" : "")
        );
      // .join();
      if (d.customerReport)
        d["dcStatus"] = d.customerReport?.datacenterStatus?.map((s) =>
          s?.datacenter?.name
            ? s.datacenter.name + " (" + DC_STATUS_DICT[s?.status] + ")"
            : ""
        );
      // .join();
      return d;
    });
    return dataArr;
  };

  closeCallender = (ev?: any) => {
    this.setState({
      ...this.state,
      showCallender: false,
    });
  };

  pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No datacenter found",
  };

  filterSuggestedTags = (filterText: string, tagList: ITag[]): ITag[] => {
    let allDataCenterList = [...this.state.datacenterOptions];

    return filterText
      ? allDataCenterList.filter(
          (tag) =>
            tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
            !this.listContainsTagList(tag, tagList)
        )
      : [];
  };

  showAllTags = (selectedItems?: ITag[] | undefined) => {
    let allDataCenterList = [...this.state.datacenterOptions];
    return this.removeDuplicates(allDataCenterList, selectedItems);
  };

  removeDuplicates(tagList: ITag[], tags?: ITag[]) {
    return tagList.filter((tag) => !this.listContainsTagList(tag, tags));
  }

  listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.some((compareTag) => compareTag.key === tag.key);
  };

  onMergedCustomersButtonClick = () => {
    this.props.history.push(`/customers/merged`);
  };

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading && <Loading isModeless={true} />}
        <Stack tokens={childrenGap24}>
          <Stack.Item>
            <Stack horizontal horizontalAlign="space-between">
              <Stack.Item>
                <PageTitle
                  icon={CustomerIcon}
                  title="Customers"
                  description="List of all customers"
                />
              </Stack.Item>
              {/* <Stack.Item>
                <PrimaryButton
                  text='Add Customer'
                  onClick={() => this.handleAddDialogOpen(true)}
                />
              </Stack.Item> */}
            </Stack>
          </Stack.Item>
          {/* <Stack.Item>
            <Stack horizontal wrap tokens={childrenGap}>
              <Stack.Item>
                <div
                  ref={(calendarBtn) => (calendarButtonElement = calendarBtn!)}
                >
                  <DefaultButton
                    text={
                      !this.state.customers.search
                        ? "Select a month"
                        : moment(this.state.customers.search.date).format(
                            "MMM-YYYY"
                          )
                    }
                    onClick={() =>
                      this.setState({ ...this.state, showCallender: true })
                    }
                    className="month-picker-btn"
                  />
                </div>
                {this.state.showCallender && (
                  <Callout
                    isBeakVisible={false}
                    // className="ms-DatePicker-callout"
                    gapSpace={0}
                    doNotLayer={false}
                    target={calendarButtonElement}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    onDismiss={() => this.closeCallender()}
                    setInitialFocus
                  >
                    <FocusTrapZone
                      firstFocusableSelector="ms-DatePicker-day--today"
                      isClickableOutsideFocusTrap
                    >
                      <Calendar
                        // eslint-disable-next-line react/jsx-no-bind
                        onSelectDate={(date: Date | null | undefined) =>
                          this._searchCustomers(date as Date)
                        }
                        onDismiss={() => this.closeCallender()}
                        isMonthPickerVisible={true}
                        value={this.state.customers.search.date}
                        firstDayOfWeek={DayOfWeek.Sunday}
                        strings={DayPickerStrings}
                        isDayPickerVisible={false}
                        highlightCurrentMonth={false}
                        highlightSelectedMonth={true}
                        showMonthPickerAsOverlay={false}
                        showGoToToday={false}
                      />
                    </FocusTrapZone>
                  </Callout>
                )}
              </Stack.Item>
              <Stack.Item>
                <Dropdown
                  placeholder="Filter by status"
                  selectedKey={this.state.customers.search.customerReportStatus}
                  styles={{ dropdown: { width: 180 } }}
                  options={DC_STATUS_DROPDOWN}
                  onChange={(e, v: IDropdownOption | undefined) => {
                    if (v) {
                      this._searchCustomers(v.key as number);
                    }
                  }}
                />
              </Stack.Item>
            </Stack>
          </Stack.Item> */}
          <Stack.Item>
            <Stack
              horizontal
              horizontalAlign="space-between"
              wrap
              tokens={childrenGap}
            >
              <Stack.Item>
                <Stack horizontal wrap tokens={childrenGap}>
                  <Stack.Item>
                    <SearchBox
                      value={this.state.customers.search.search}
                      styles={{ root: { width: "300px" } }}
                      placeholder="Customer Name/SAP Code"
                      onChange={(e, value) =>
                        this._searchCustomers(value as string, "search")
                      }
                    />
                  </Stack.Item>
                  {this.state.showStatusFilter === false && (
                    <Stack.Item className="filter-btn">
                      <TooltipHost
                        content={"Customer Report Status Filter"}
                        id={`cRS`}
                        calloutProps={{ gapSpace: 0 }}
                        styles={{ root: { display: "inline-block" } }}
                      >
                        <span
                          onClick={() =>
                            this.setState({
                              ...this.state,
                              showStatusFilter: true,
                            })
                          }
                        >
                          <Icon
                            path={mdiFilterOutline}
                            size={1.0}
                            className="pointer"
                            color={THEME.palette.neutralLighterAlt}
                          />
                        </span>
                      </TooltipHost>
                    </Stack.Item>
                  )}
                  {this.state.showStatusFilter === true && (
                    <>
                      <Stack.Item>
                        <div
                          ref={(calendarBtn) =>
                            (calendarButtonElement = calendarBtn!)
                          }
                        >
                          <DefaultButton
                            text={
                              !this.state.customers.search
                                ? "Select a month"
                                : moment(
                                    this.state.customers.search.date
                                  ).format("MMM-YYYY")
                            }
                            onClick={() =>
                              this.setState({
                                ...this.state,
                                showCallender: true,
                              })
                            }
                            className="month-picker-btn"
                          />
                        </div>
                        {this.state.showCallender && (
                          <Callout
                            isBeakVisible={false}
                            // className="ms-DatePicker-callout"
                            gapSpace={0}
                            doNotLayer={false}
                            target={calendarButtonElement}
                            directionalHint={DirectionalHint.bottomLeftEdge}
                            onDismiss={() => this.closeCallender()}
                            setInitialFocus
                          >
                            <FocusTrapZone
                              firstFocusableSelector="ms-DatePicker-day--today"
                              isClickableOutsideFocusTrap
                            >
                              <Calendar
                                // eslint-disable-next-line react/jsx-no-bind
                                onSelectDate={(date: Date | null | undefined) =>
                                  this._searchCustomers(date as Date, "date")
                                }
                                onDismiss={() => this.closeCallender()}
                                isMonthPickerVisible={true}
                                value={this.state.customers.search.date}
                                firstDayOfWeek={DayOfWeek.Sunday}
                                strings={DayPickerStrings}
                                isDayPickerVisible={false}
                                highlightCurrentMonth={false}
                                highlightSelectedMonth={true}
                                showMonthPickerAsOverlay={false}
                                showGoToToday={false}
                                maxDate={moment().subtract(1, "month").toDate()}
                              />
                            </FocusTrapZone>
                          </Callout>
                        )}
                      </Stack.Item>
                      <Stack.Item>
                        <Dropdown
                          placeholder="Filter by status"
                          selectedKey={
                            this.state.customers.search.customerReportStatus
                          }
                          styles={{ dropdown: { width: 250 } }}
                          options={DC_STATUS_DROPDOWN}
                          onChange={(e, v: IDropdownOption | undefined) => {
                            if (v) {
                              this._searchCustomers(v.key as number, "status");
                            }
                          }}
                        />
                      </Stack.Item>
                      <Stack.Item>
                        <TagPicker
                          removeButtonAriaLabel="Remove"
                          selectedItems={this.state.selectedDatacenters}
                          onResolveSuggestions={this.filterSuggestedTags as any}
                          pickerSuggestionsProps={this.pickerSuggestionsProps}
                          onEmptyResolveSuggestions={this.showAllTags}
                          inputProps={{
                            placeholder: "Search datacenters...",
                          }}
                          onBlur={() => this._searchCustomers("", "datacenter")}
                          onChange={(items: any) => {
                            let datacenterIds: string[] = [];
                            items.forEach((i: any) => {
                              datacenterIds.push(i.key);
                            });
                            this.setState({
                              customers: {
                                ...this.state.customers,
                                search: {
                                  ...this.state.customers.search,
                                  datacenterIds: datacenterIds.join(","),
                                  offset: 0,
                                  limit: 12,
                                },
                              },
                              selectedDatacenters: items,
                            });
                          }}
                        />
                      </Stack.Item>
                    </>
                  )}
                </Stack>
              </Stack.Item>
              <Stack.Item>
                <PrimaryButton
                  text="Merge Customers"
                  onClick={this.onMergedCustomersButtonClick}
                />
              </Stack.Item>
            </Stack>
          </Stack.Item>
          <Stack.Item>
            <div>
              {this.state.customers &&
              this.state.customers.data &&
              this.state.customers.data.length > 0 ? (
                <Fabric>
                  <DetailsList
                    items={this.state.customers.data}
                    columns={[
                      {
                        key: "number",
                        name: "S. No",
                        fieldName: "number",
                        minWidth: 30,
                        maxWidth: 40,
                        isResizable: true,
                      },
                      {
                        key: "name",
                        name: "Name",
                        fieldName: "name",
                        minWidth: 220,
                        maxWidth: 370,
                        isResizable: true,
                      },
                      {
                        key: "regSapNo",
                        name: "Registered SAP Code",
                        fieldName: "regSapNo",
                        minWidth: 160,
                        maxWidth: 170,
                        isResizable: true,
                      },
                      {
                        key: "customerLocation",
                        name: "Location",
                        fieldName: "customerLocation",
                        minWidth: 350,
                        maxWidth: 600,
                        isResizable: true,
                      },
                      {
                        key: "dcStatus",
                        name: "Report Status",
                        fieldName: "dcStatus",
                        minWidth: 300,
                        maxWidth: 600,
                        isResizable: true,
                      },
                      // { key: "email", name: "Email", fieldName: "email", minWidth: 100, maxWidth: 200, isResizable: true },
                      {
                        key: "cemName",
                        name: "CEM",
                        fieldName: "cemName",
                        minWidth: 130,
                        maxWidth: 150,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 80,
                        maxWidth: 110,
                        isResizable: true,
                      },
                    ]}
                    compact={true}
                    setKey="set"
                    onRenderItemColumn={this._renderItemColumn as any}
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                    onRenderRow={this._onRenderRow}
                  />
                </Fabric>
              ) : (
                <NoDataTile title="No Customers Found"></NoDataTile>
              )}
            </div>
          </Stack.Item>
          <Stack.Item>
            <CustomPagination
              name="Customers"
              search={this.state.customers.search}
              totalCount={this.state.customers.totalCount}
              getFrom={this.getCustomersFrom}
            />
          </Stack.Item>
          {/* <Stack.Item align="end" className="mr-6">
            <span
              onClick={
                this.state.customers.search.offset === 0
                  ? undefined
                  : () =>
                      this.getCustomersFrom(
                        this.state.customers.search.offset -
                          this.state.customers.search.limit
                      )
              }
              className={
                this.state.customers.search.offset === 0
                  ? "btn-disabled"
                  : "btn-enabled pointer"
              }
            >
              <Icon
                path={mdiChevronLeft}
                size={0.9}
                className="btnIcon"
                style={{
                  marginBottom: -6,
                  marginRight: -8,
                  color: BRAND_SECONDARY,
                }}
              />
              <DefaultButton
                text="Previous"
                className="borderless-btn"
                // onClick={() =>
                //   this.getCustomersFrom(
                //     this.state.customers.search.offset -
                //       this.state.customers.search.limit
                //   )
                // }
                // disabled={this.state.customers.search.offset === 0}
              />
            </span>
            <span className="nxt-prv-btn-border"></span>
            <span
              onClick={
                !this.state.customers.hasMoreCustomers
                  ? undefined
                  : () =>
                      this.getCustomersFrom(
                        this.state.customers.search.offset +
                          this.state.customers.search.limit
                      )
              }
              className={
                !this.state.customers.hasMoreCustomers
                  ? "btn-disabled"
                  : "btn-enabled pointer"
              }
            >
              <DefaultButton
                text="Next"
                className="borderless-btn"
                // onClick={() =>
                //   this.getCustomersFrom(
                //     this.state.customers.search.offset +
                //       this.state.customers.search.limit
                //   )
                // }
                // disabled={!this.state.customers.hasMoreCustomers}
              />
              <Icon
                path={mdiChevronRight}
                size={0.9}
                className="btnIcon"
                style={{
                  marginBottom: -6,
                  marginLeft: -8,
                  color: BRAND_SECONDARY,
                }}
              />
            </span>
          </Stack.Item> */}
          {/* <Stack.Item align="end">
            <DefaultButton
              text="Previous"
              onClick={() =>
                this.getCustomersFrom(
                  this.state.customers.search.offset -
                    this.state.customers.search.limit
                )
              }
              disabled={this.state.customers.search.offset === 0}
            />
            &nbsp;&nbsp;
            <DefaultButton
              text="Next"
              onClick={() =>
                this.getCustomersFrom(
                  this.state.customers.search.offset +
                    this.state.customers.search.limit
                )
              }
              disabled={!this.state.customers.hasMoreCustomers}
            />
          </Stack.Item> */}
        </Stack>

        {/* {this.state.iscustomersLoaded && <AddCustomerRacksDialog closeAddDialog={() => this.handleCloseCustomerRackDialog()} />} */}
      </React.Fragment>
    );
  }
}
const childrenGap24: IStackTokens = { childrenGap: 24 };

export default withRouter(
  withConfirmDialogContext(withToastContext(CustomerMain))
);
